import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withCookies } from 'react-cookie';
import { NotificationBar, Notification, TrackableLink } from '@surfline/quiver-react';
import { CLICKED_SUBSCRIBE_CTA } from '../../common/constants';

const SUBSCRIBE_CTA_PROPERTIES = { ctaLocation: 'upsell bar' };
class NotificationBarController extends Component {
  constructor(props) {
    super(props);
    this.giftCardsLinkRef = React.createRef();
    this.freeTrialLinkRef = React.createRef();
  }

  renderBaseNotification = () => {
    const { cookies } = this.props;
    const dismissDuration = 1000 * 60 * 60 * 24 * 8;
    const savedTimestamp = cookies.get('dismissTimestamp');
    const nextPresentationTime =
      savedTimestamp != null ? dismissDuration + parseInt(savedTimestamp, 10) : 0;

    const dismissBannerHandler = () => {
      cookies.set('dismissTimestamp', Date.now(), null);
    };

    return nextPresentationTime < Date.now() ? (
      <Notification
        closable
        type="large"
        level="information"
        onCloseComplete={dismissBannerHandler}
      >
        <TrackableLink
          ref={this.freeTrialLinkRef}
          eventName={CLICKED_SUBSCRIBE_CTA}
          eventProperties={SUBSCRIBE_CTA_PROPERTIES}
        >
          <a ref={this.freeTrialLinkRef} href="/upgrade" className="quiver-notification__tag-line">
            <span className="quiver-notification__tag-line__full-text">
              Ad-free Cams. Extended Forecasts.
            </span>
            {' START FREE TRIAL.'}
          </a>
        </TrackableLink>
      </Notification>
    ) : null;
  };

  // getGiftCardEventProperties = () => ({
  //   linkLocation: 'notification bar',
  //   linkName: 'gift cards',
  //   linkUrl: '/gift-cards',
  // });

  // // Disabling renderGiftCardsNotification since PROMOTE_GIFT_CARDS is not used.
  // renderGiftCardsNotification = () => (
  //   <Notification type="large" level="information">
  //     <TrackableLink
  //       ref={this.giftCardsLinkRef}
  //       eventName="Clicked Link"
  //       eventProperties={this.getGiftCardEventProperties}
  //     >
  //       <a ref={this.giftCardsLinkRef} href="/gift-cards" className="quiver-notification__tag-line">
  //         <span className="quiver-notification__tag-line__full-text">
  //           Give the Gift of Surfline Premium.
  //         </span>{' '}
  //         Digital Gift Cards Now Available
  //       </a>
  //     </TrackableLink>
  //   </Notification>
  // );

  renderPaymentWarningsNotification = () => {
    const { warnings, isPremium } = this.props;
    const computeWarningType = () => {
      const warningTypes = warnings.map(({ type }) => type);
      if (warningTypes.includes('failedPayment')) return 'failedPayment';
      if (warningTypes.includes('invalidZip') && isPremium) return 'invalidZip';
      return null;
    };
    const warningType = computeWarningType();
    let notification =
      'We are unable to renew your membership due to a payment problem. To keep Surfline Premium, ';
    const linkText = 'Please update your payment details.';
    if (warningType === 'invalidZip') {
      notification = 'Make sure you keep Surfline Premium. ';
    }
    return (
      <div>
        {warningType ? (
          <Notification closable type="warning-notification" level="error">
            <span>{notification}</span>
            <a href="/account/subscription#payment-details">{linkText}</a>
          </Notification>
        ) : null}
      </div>
    );
  };

  renderNotification = () => {
    const { isPremium, warnings, slDisableNotificationCTA } = this.props;

    if (slDisableNotificationCTA === 'on') return null;

    if (warnings.length) {
      return this.renderPaymentWarningsNotification();
    }
    if (isPremium || slDisableNotificationCTA === 'on') return null;

    return this.renderBaseNotification();
  };

  render() {
    return <NotificationBar largeNotification={this.renderNotification()} />;
  }
}

NotificationBarController.propTypes = {
  isPremium: PropTypes.bool.isRequired,
  slDisableNotificationCTA: PropTypes.string,
  cookies: PropTypes.shape({ get: PropTypes.func, set: PropTypes.func }).isRequired,
  warnings: PropTypes.arrayOf(
    PropTypes.shape({
      subscriptionId: PropTypes.string,
      cardId: PropTypes.string,
      planId: PropTypes.string,
      type: PropTypes.string,
      status: PropTypes.string,
    }),
  ),
};

NotificationBarController.defaultProps = {
  slDisableNotificationCTA: 'off',
  warnings: [],
};

export default withCookies(NotificationBarController);
